/**
 * 上滑弹窗
 * 1. 灰色背景动效
 * 2. 上滑弹窗动效
 */
import * as React from 'react';
import { ModalMask } from '@/src/components';
import { animationTemp, throttle } from '@/src/utils';
import '@/components/SlideUpModal/index.css';

interface Props {
  /**
     * 上滑弹窗展示状态:
     * true:展开
     * false:关闭
     */
  slideUpModalStatus: boolean;
  /** 关闭上滑弹窗 */
  closeSlideUpModal: () => void;
}

interface State {
  /** 展示活动弹窗（内部状态） */
  showDialog: boolean;
}

class SlideUpModal extends React.Component<Props, State> {
  activityDialogRef: any
  /** 活动弹窗高度 */
  dialogHeight = 0;
  /** 防止layout过程中频繁调用handleLayoutCallback */
  modalStatus = false;

  constructor(props: any) {
    super(props);
    this.state = {
      showDialog: false
    };
  }

  componentDidUpdate(prevProps: Readonly<Props>): void {
    if (this.props.slideUpModalStatus !== prevProps.slideUpModalStatus && this.props.slideUpModalStatus) {
      this.handleActivityDialogShow();
    }
    if (this.props.slideUpModalStatus !== prevProps.slideUpModalStatus && !this.props.slideUpModalStatus) {
      this.handleActivityDialogHidden();
    }
  }

  /**
     * 浮层展示
     */
  handleActivityDialogShow = () => {
    this.setState({
      showDialog: true
    }, () => {
      this.modalStatus = true;
    });
  }

  /**
     * onLayout完成回调，展示浮层
     */
  handleLayoutCallback = () => {
    if (!this.modalStatus) {
      return;
    }
    /** modalStatus置为false，阻止layout过程中重复调用展开动画 */
    this.modalStatus = false;
    // 平移高度
    const transfromHeight = this.dialogHeight;
    const keyFrames = {
      from: { bottom: `-${transfromHeight}` },
      to: { bottom: 0 }
    };
    const animShow = animationTemp(keyFrames);
    this.activityDialogRef?.setAnimation(animShow, () => {});
  }

  /**
     * 浮层消失
     */
  handleActivityDialogHidden = throttle(() => {
    // 平移高度
    const transfromHeight = this.dialogHeight;
    const keyFrames = {
      from: { bottom: 0 },
      to: { bottom: `-${transfromHeight}` }
    };
    const animHidden = animationTemp(keyFrames);
    this.activityDialogRef?.setAnimation(animHidden, (callback) => {
      if (callback.state === 'end') {
        this.setState({
          showDialog: false
        });
      }
    });
  }, 300)

  render() {
    const {
      slideUpModalStatus,
      closeSlideUpModal,
      children
    } = this.props;
    const {
      showDialog
    } = this.state;
    return (
      <>
        <ModalMask
          visible={slideUpModalStatus}
          onClose={() => closeSlideUpModal?.()}
        />
        {
          showDialog
            ? (
              <view
                className="dialog-bg"
                onClick={() => {}}
                ref={(ref) => { this.activityDialogRef = ref; }}
                // eslint-disable-next-line react/no-unknown-property
                onLayout={(frame) => {
                  this.dialogHeight = frame.detail.height;
                  this.handleLayoutCallback();
                }}
              >
                {children}
              </view>
            ) : null
        }
      </>
    );
  }
}

export default SlideUpModal;
